/*eslint-disable */
import LayerService from '@/services/layers/LayerService';

// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax,import/no-extraneous-dependencies
import store        from '@/store/index';

import {
  DivIcon,
  LayerGroup,
  LeafletEvent,
  Marker,
  Util,
}                                                     from 'leaflet';
import { IFeatureCollection, AllMergedCategorySpots } from '@/interfaces/IFeatureCollection';
import { IParkingSpotData }                           from '@/interfaces/IParkingSpotData';
import IFeature                                       from '@/interfaces/IFeature';
import { IParkingData }                               from '@/interfaces/IParkingData';
import { IModalData }                                 from '@/services/layers/IModalData';
import Mustache                                       from 'mustache';

interface MarkerIcon {
  occupiedSpace: {
    title: string;
    icon: string;
    state: string;
  };
  free: {
    icon: string;
    title: string;
    state: string;
  }
}

export default class ParkingLayerService extends LayerService {
  protected clusteringConstant = 18;
  protected icoMarker: MarkerIcon = {
    free: {
      title: 'Wolne miejsce',
      icon: 'miejsce-parkingowe-wolne.svg',
      state: 'free',
    },
    occupiedSpace: {
      title: 'Zajęte miejsce',
      icon: 'miejsce-parkingowe-zajete.svg',
      state: 'occupied'
    },
  };

  onClick = (e: LeafletEvent, metaData: IParkingSpotData, leafletMarker: Marker<any>): void => {
    const parkings = store.state.parkings.features;
    const selectedParking: IFeature = parkings.find((o) => {
      const data = o.properties as IParkingData;
      return data.code === metaData.parkingCode;
    }) as IFeature;

    const lastStatus = !!selectedParking.properties.last_status
                       ? selectedParking.properties.last_status.occupancy : [];
    const parkingSpots = !!selectedParking.properties.parkingSpots
                         ? selectedParking.properties.parkingSpots : [];
    const mergedArr = [...lastStatus, ...parkingSpots];
    const mergedArrValues = this.mergeObjectsInUnique(mergedArr, 'category');
    const allCategorySpots = this.sumParkingCategoryPlaces(mergedArrValues, 'spots');
    const allCategoryOccupancySpots = this.sumParkingCategoryPlaces(
      mergedArrValues, 'occupied',
    );

    let parkingSpotsTable: string = '';
    mergedArrValues.forEach((item: AllMergedCategorySpots) => {
      parkingSpotsTable += `<tr>
                        <td>${ !!item.category ? item.category : this.noData }</td>
                        <td>${ !!item.spots ? item.spots : this.noData }</td>
                        <td>${ !!item.occupied ? item.occupied : this.noData }</td>
                        </tr>`;
    });


    const hasSpots = !!parkingSpotsTable
                     ? 'parking-data--has-data'
                     : 'parking-data--empty-data';

    if (!!selectedParking) {
      const payload: IParkingData = selectedParking.properties as IParkingData;

      const template: string = `

      <div class="parking-data">
        <div class="parking-data__description">${ payload.description }</div>
        <div class="${ hasSpots }">
          <div class="parking-data__table">
            <table>
              <thead>
                <th>Kategoria miejsc</th>
                <th>Wszystkie miejsca</th>
                <th>Zajęte miejsca</th>
              </thead>
              <tbody>
                ${ parkingSpotsTable }
              </tbody>
              <tfoot>
                <th>Razem:</th>
                <th>${ !!allCategorySpots ? allCategorySpots : '-' }</th>
                <th>${ !!allCategoryOccupancySpots ? allCategoryOccupancySpots : '-' }</th>
              </tfoot>
            </table>
          </div>
          <div class="empty-data">
            Brak informacji o aktualnej zajętości.
          </div>
        </div>
      </div>
      `;

      const lastUpdate = !!metaData.last_status && !!metaData.last_status.date
                         ? metaData.last_status.date as string
                         : this.noData;

      const placeState = !!metaData.last_status && !metaData.last_status.occupied
                         ? this.icoMarker.free : this.icoMarker.occupiedSpace;

      const title = `${ placeState.title } - ${ payload.name }`;

      const modalData: IModalData = {
        title: title,
        content: Mustache.render(template, {
          parkingSpot: metaData,
          parking: payload,
        }),
        navigationPoint: leafletMarker,
        lastUpdate: lastUpdate,
        icon: placeState.icon,
      };

      if (placeState.state.includes('free')) {
        store.commit('displayModal', modalData);
      }
    }
  };

  redrawLayer = (): LayerGroup<any> => {
    const points: IFeatureCollection = store.state.parkingSpots;

    const filterPoints: IFeatureCollection = {
      type: points.type,
      features: points.features
    };

    return this.generatePruneClusterMarkerLayer(filterPoints);
  };

  protected generateHtmlPointTemplate = (metaData: any, leafletMarker: Marker<any>): string => {
    const icon = !!metaData.last_status && !metaData.last_status.occupied
                 ? this.icoMarker.free.icon : this.icoMarker.occupiedSpace.icon;

    const template: string = `
        <div
            class="map-simple-icon map-simple-icon--parking-meter"
            style='background-image: url("${ require('@/assets/img/map-icons/' + icon) }")'>
        <div>
      `;

    return template;
  }
}
